import {Box, Grid, Theme} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {localized} from '../../../../../i18n/i18n';
import {AppState} from '../../../../../state/store';
import {getValueWeighthWithUnitByCulture} from '../../../../../utilities/helpers/culture-settings-helper';
import {getConfigurationParamByName} from '../../../../../utilities/helpers/product-helper';
import {requiredValidatorDynamicMsg} from '../../../../../utilities/platform-helpers/validator-helper';
import {ButtonInput} from '../../form/button-input';
import {TextInputLabel} from '../../form/text-input-label';
import {disabledButtonColor} from '../../../../../styles/color-constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formBtnInputBox: {
      width: '250px',
      display: 'flex',
      justifyContent: 'center',
      [`& fieldset`]: {
        border: '1px solid',
        borderColor: disabledButtonColor,
        borderRadius: 0,
      },
    },
  }),
);

interface PropsFromParent {
  formName: string;
  value1: string;
  value2: string;
  valueUnit?: string;
  btnLabel1?: string;
  btnLabel2?: string;
  label: string;
  tooltipLabel?: string;
  buttonPressedCallback?: (value: boolean) => void;
  defaultValue?: string;
}
export const BinaryButtonInput: FC<PropsFromParent> = React.memo((props) => {
  const classes = useStyles();
  const {unitsId} = useSelector((store: AppState) => store.urlSettingsReducer.cultureUrlParameters);
  const selectedProduct = useSelector((store: AppState) => store.projectReducer.selectedProduct);
  return (
    <>
      <Grid item xs={7}>
        <TextInputLabel name={props.formName} label={props.label} tooltipLabel={props.tooltipLabel} />
      </Grid>
      <Grid item xs={5}>
        <Box className={classes.formBtnInputBox}>
          <ButtonInput
            name={props.formName}
            formFieldName={props.formName}
            callBack={props.buttonPressedCallback}
            validators={{
              ...requiredValidatorDynamicMsg(localized('FieldIsRequired')),
            }}
            value1={props.value1 + (props.valueUnit ? ` ${props.valueUnit}` : '')}
            value2={props.value2 + (props.valueUnit ? ` ${props.valueUnit}` : '')}
            defaultValue={getConfigurationParamByName(selectedProduct, props.formName)}
            btnLabel1={props.btnLabel1 ? props.btnLabel1 : getValueWeighthWithUnitByCulture(unitsId, props.value1)}
            btnLabel2={props.btnLabel2 ? props.btnLabel2 : getValueWeighthWithUnitByCulture(unitsId, props.value2)}
          />
        </Box>
      </Grid>
    </>
  );
});
